import {
  type GetVendorsListFilters,
  type GetVendorsListItem,
  useGetVendorsList,
} from "@birdwatch/client";

export type VendorListItem = GetVendorsListItem;

export const useAllVendors = (filters?: Partial<GetVendorsListFilters>) =>
  useGetVendorsList()
    .filters(filters ?? {})
    .take(-1)
    .get();
